import { render, staticRenderFns } from "./askModal.vue?vue&type=template&id=96c47f38&scoped=true&"
import script from "./askModal.vue?vue&type=script&lang=js&"
export * from "./askModal.vue?vue&type=script&lang=js&"
import style0 from "./askModal.vue?vue&type=style&index=0&id=96c47f38&lang=less&scoped=true&"
import style1 from "./askModal.vue?vue&type=style&index=1&lang=css&"
import style2 from "./askModal.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c47f38",
  null
  
)

export default component.exports